export const roles = {
  student: 'student',
  admin: 'admin',
  teacher: 'classroom-teacher',
  curator: 'curator',
  verification: 'verification-specialist',
  content: 'content-manager'
}
export const roleTranslates = {
  [roles.student]: 'Ученик',
  [roles.admin]: 'Администратор',
  [roles.teacher]: 'Класс. рук.',
  [roles.curator]: 'Куратор',
  [roles.verification]: 'Спец. по режиму',
  [roles.content]: 'Контент-менеджер'
}

export const roleTranslatesBadge = {
  [roles.student]: 'У',
  [roles.admin]: 'А',
  [roles.teacher]: 'КР',
  [roles.curator]: 'К',
  [roles.verification]: 'С',
  [roles.content]: 'КМ'
}

export const roleBadges = {
  [roles.student]: 'success',
  [roles.admin]: 'danger',
  [roles.teacher]: 'info',
  [roles.curator]: 'warning',
  [roles.verification]: 'secondary',
  [roles.content]: 'primary'
}

export const roleFilters = {
  [roleTranslates[roles.admin]]: roles.admin,
  [roleTranslates[roles.verification]]: roles.verification,
  [roleTranslates[roles.content]]: roles.content,
  [roleTranslates[roles.teacher]]: roles.teacher,
  [roleTranslates[roles.student]]: roles.student,
  [roleTranslates[roles.curator]]: roles.curator
}
